import { type AmortisationCapability } from '../integration/status';

export const isAmortisationSchemesSupported = (
  amortisationCapability: AmortisationCapability | undefined,
) => amortisationCapability === 'pull';
